import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import currencySymbols from 'constants/currencies';

const CurrencySymbol = ({ currencyCode, className }) => (
  <>
    <span>{currencySymbols[currencyCode] || currencyCode}</span>
    <FormattedNumber value={0} minimumFractionDigits={0}>
      {(formattedNumber) => <span className={className}>{formattedNumber.replace('0', '').trim()}</span>}
    </FormattedNumber>
  </>
);

CurrencySymbol.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default CurrencySymbol;
